<template> <!-- we can use functional component -->
  <div>
    <div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
          <h4 v-if="item">
            Callcenter Agent settings:
          </h4>
				</div>
				<div class="ibox-content">

					<div class="row">
						<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="save()" v-if="!loading">

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Name:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="name" caption="name" v-model="item.name" type="name" />
									</div>
								</div>

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Description:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="description" caption="description" v-model="item.description" type="text" />
									</div>
								</div>
								<!---->
								<div class="row">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 ">Extension:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
										<!-- <input name="extension" type="text" v-model="item.extension" class="ng-pristine ng-untouched ng-valid ng-empty" validation-initialized="true" autocomplete="description"> -->
											<select v-model="item.phone" class="form-control">
												<option v-for="(phone, index) in phones" :key="index" v-bind:value="phone.name">
													{{ phone.name }} ({{phone.description}})
												</option>
											</select>
										</div>
								</div>

								<!---->
								<hr>
								<div class="row submit-button-container">
									<button type="submit" :disabled="sendInProgress" ref="submitbtn" class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" style="display: block;">
										<span class="ladda-label">Save</span>
										<span class="fas fa-spinner fa-pulse"></span>
										<div class="ladda-progress" style="width: 0px"></div>

									</button>
								</div>
							</form>
						</div>
					</div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;" ng-if="options.showProgress">
            <div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope" ng-if="options.showProgress" style="display: block;">
              <div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div><!-- end ngIf: options.showProgress --></div><!-- end ngIf: options.showProgress -->
          </div>
		</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {CallcenterAgentsService} from "../../services/CallcenterAgentsService";
export default {
	props: ["id", "isNew"],
	data: () => ({loading: false, item: null, sendInProgress: false, openList: false, phones: [], people: [], person: {role: 4, email: null}}),
	created() {
		let $injector = this.$root.angularInjector;

		let CoreApiService = $injector.get("CoreApiService");

		this.callcenterAgentsService = new CallcenterAgentsService(CoreApiService);

		this.phonesService = $injector.get("PhonesApiService");
		this.SwalService = $injector.get("SwalService");

		if (this.isNew) {
			this.item = {};
		}
	},
	async mounted() {
		let promises = [];
		this.loading = true;
		if (!this.isNew) {
			// let phones = await this.phonesService.getPhonesList();
			promises.push(this.loadItemToEdit());
		}
		// else {
		// 	promises.push(this.loadPeopleList())
		// }
		promises.push(this.loadPhones());
		await Promise.all(promises);
		this.loading = false;
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	methods: {
		async loadItemToEdit() {
			this.sourceItem = await this.callcenterAgentsService.get(this.id);
			this.item = Object.assign({}, this.sourceItem);
			delete this.item.id;
		},
		async loadPhones() {
			let response = await this.phonesService.getPhonesList();
			console.info("phones response", response);
			this.phones = response.data;
		},
		async save() {
			// let result;
			this.sendInProgress = true;
			try {
				if (this.isNew) {
					await this.callcenterAgentsService.create(this.item);
				}
				else {
					await this.callcenterAgentsService.update(this.sourceItem.id, this.item);
				}
				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendInProgress = false;
			}
		}
	}
};

function getErrorMessage(e) {
	if (e.message == "Bad request") {
		if (e.key == "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key == "error_email_exists") {
			return "Duplicate email";
		}
	}
	return e.message || e.statusText || e || "Error";
}
</script>
